/* eslint react/jsx-no-bind:0 */
import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Row, Col, Button, Table, MenuItem, DropdownButton } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import { PropTypes } from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  reduxForm,
  propTypes,
  formValueSelector
} from 'redux-form'
import {
  fetchActiveSeasons,
  deleteEvent,
  cancelEvent,
  copyEvent,
  approveRules,
  denyRules,
  resetEventWizard
} from "../../../redux/actions/action_event";
import {
  videoblue,
  blue,
  red,
  warning,
  green,
  StatusDescription,
} from '../../../utils/constants';
import ContentWrapper from "../../../components/layout/ContentWrapper";

const formName = 'eventinfo'

class SearchResults extends Component {

  static propTypes = {
    ...propTypes
  }
  constructor(props) {
    super(props);
    this.handleOnCopyEvent = this.handleOnCopyEvent.bind(this);
    this.handleOnDeleteEvent = this.handleOnDeleteEvent.bind(this);
    this.handleOnCancelEvent = this.handleOnCancelEvent.bind(this);
    this.handleOnApproveRules = this.handleOnApproveRules.bind(this);
    this.handleOnDenyRules = this.handleOnDenyRules.bind(this);
    this.setStatusColor = this.setStatusColor.bind(this);
    this.handleViewEventDetails = this.handleViewEventDetails.bind(this);
  }

  handleOnApproveRules(eventId) {
    const { dispatch } = this.props;
    dispatch(approveRules(eventId));
  }
  handleOnDenyRules(eventId) {
    const { dispatch } = this.props;
    dispatch(denyRules(eventId));
  }
  handleOnCopyEvent(eventId) {
    const { dispatch } = this.props;
    const event = {
      eventId
    }
    dispatch(copyEvent(event));
  }
  handleOnDeleteEvent(eventId) {

    const event = {
      eventId
    }
    const customBody = (
      <p>
        <i className="fa fa-exclamation-triangle text-danger" style={{ color: 'red' }} />
        &nbsp;&nbsp;
        <span>Are you sure you want to delete this event? </span>
      </p>
    )

    Dialog.setOptions({
      defaultOkLabel: 'Delete Event',
      defaultCancelLabel: 'Cancel',
      primaryClassName: 'btn-danger'
    })
    Dialog.Action(
      'Delete Event',
      () => this.props.deleteEvent(event),
      'btn-danger'
    )
    this.dialog.show({
      body: customBody,
      title: 'Confirm Event Deletion',
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => this.props.deleteEvent(event))
      ],
      bsSize: 'small'
    })
  }

  handleOnCancelEvent(eventId) {
    const event = {
      eventId
    }
    const { searchResults } = this.props;
    const { cancelStatus } = _.find(searchResults, { eventId: parseInt(eventId) });

    const customBody = (
      <p>
        <i className="fa fa-exclamation-triangle text-danger" style={{ color: 'red' }} />
        &nbsp;&nbsp;
        <span>Are you sure you want to cancel this event? </span>
      </p>
    )
    const customBody1 = (
      <p>
        <i className="fa fa-exclamation-triangle text-danger" style={{ color: 'red' }} />
        &nbsp;&nbsp;
        <span>Event can not be Canceled because there is still an Advancer/Alternate assigned to a Division. </span>
      </p>
    )
    Dialog.setOptions({
      defaultOkLabel: 'Cancel Event',
      defaultCancelLabel: 'Cancel',
      primaryClassName: 'btn-danger'
    })
    Dialog.Action(
      'Cancel Event',
      () => this.props.cancelEvent(event),
      'btn-danger'
    )
    if (cancelStatus === true) {
      this.dialog.show({
        body: customBody1,
        actions: [
          Dialog.CancelAction()
        ],
        bsSize: 'small'
      })
    } else {
      this.dialog.show({
        body: customBody,
        title: 'Confirm Event Cancellation',
        actions: [
          Dialog.CancelAction(),
          Dialog.OKAction(() => this.props.cancelEvent(event))
        ],
        bsSize: 'small'
      })
    }
  }
  handleViewEventDetails(eventId) {
    this.props.onViewEventDetails(eventId);
  }

  setStatusColor(status) {
    switch (status) {
      case StatusDescription.SetupNotCompleted:
        {
          return warning
        }
      case StatusDescription.UpcomingEvent:
        {
          return videoblue
        }
      case StatusDescription.PendingPost:
        {
          return red
        }
      case StatusDescription.PendingApproval:
        {
          return red
        }
      case StatusDescription.RulesDenied:
        {
          return red
        }
      case StatusDescription.Completed:
        {
          return green
        }
      case StatusDescription.Canceled:
        {
          return red
        }
    }
  }
  render() {
    const {
      searchResults,
      isAdministrator
    } = this.props;

    const recordsFound = (searchResults !== undefined) && (searchResults.length > 0)

    if (recordsFound === false) {
      return (<span style={{ color: warning }}>
        <i className='fa fa-info-circle' />&nbsp;&nbsp;No events found
      </span>)
    }
    return (
      <ContentWrapper>
        <Dialog ref={(el) => { this.dialog = el }} />
        <Row form={formName}>
          <Col xs={12}>
            <Table striped>
              <thead>
                <tr>
                  <th>Event Name</th>
                  <th>Event Type</th>
                  <th>Center</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Director</th>
                  <th>Event Email</th>
                  <th>Status</th>
                  <th style={{ width: "30px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  searchResults && searchResults.map((item, key) =>
                  (<tr key={key}>
                    <td>
                      {key + 1}{' .'} <Button className="btn btn-default" style={{ color: blue }} onClick={() => this.handleViewEventDetails(item.eventId)}>
                        {_.startCase(item.name)}
                      </Button>
                    </td>
                    <td>{item.eventType}</td>
                    <td>{item.centerName}</td>
                    <td>{item.city}</td>
                    <td>{item.state}</td>
                    <td>{moment(item.startDate).format('MM/DD/YYYY')}</td>
                    <td>{moment(item.endDate).format('MM/DD/YYYY')}</td>
                    <td>{item.directorName}</td>
                    <td>{item.eventEmail}</td>
                    <td><span style={{ color: this.setStatusColor(item.eventStatus), fontSize: '90%' }}>{item.status}</span></td>
                    <td>
                      <DropdownButton pullRight noCaret title={<i className="fa fa-angle-right" />} id={"cloneActionBtn" + key} disabled={!isAdministrator && item.depositPaidOn !== null}>
                        {
                          <div style={{ textAlign: 'left', paddingLeft: '10px' }}>
                            {isAdministrator &&
                              <MenuItem
                                eventKey={item.eventId}
                                onSelect={this.handleOnApproveRules}
                                style={{ color: green }}
                                hidden={item.status !== StatusDescription.PendingApproval}
                              >
                                <i className="fa fa-thumbs-up  text-muted mr-sm" style={{ color: green }} />&nbsp;Approve Rules
                              </MenuItem>
                            }
                            {isAdministrator &&
                              <MenuItem
                                eventKey={item.eventId}
                                onSelect={this.handleOnDenyRules}
                                style={{ color: red }}
                                hidden={item.status !== StatusDescription.PendingApproval}
                              >
                                <i className="fa fa-thumbs-down  text-muted mr-sm" style={{ color: red }} />Deny Rules
                              </MenuItem>
                            }
                            <MenuItem
                              eventKey={item.eventId}
                              onSelect={this.handleOnDeleteEvent}
                              style={{ color: red }}
                              hidden={(item.status === StatusDescription.Completed) || (item.depositPaidOn !== null)}
                            >
                              <i className="fa fa-trash-o  text-muted mr-sm" style={{ color: red }} />&nbsp;Delete Event
                            </MenuItem>
                            {isAdministrator &&
                              <MenuItem
                                eventKey={item.eventId}
                                onSelect={this.handleOnCancelEvent}
                                style={{ color: red }}
                                hidden={(item.depositPaidOn === null) || (item.status === StatusDescription.Completed) || (item.status === StatusDescription.Canceled)}
                              >
                                <i className="fa fa-ban  text-muted mr-sm" style={{ color: red }} />Cancel Event
                              </MenuItem>
                            }
                          </div>
                        }
                      </DropdownButton>
                    </td>
                  </tr>))
                }
              </tbody>
            </Table>
          </Col>
        </Row>
      </ContentWrapper>)
  }
}
SearchResults.propTypes = {
  dispatch: PropTypes.func,
  searchResults: PropTypes.array,
  deleteEvent: PropTypes.func,
  cancelEvent: PropTypes.func,
  onViewEventDetails: PropTypes.func,
  refreshSearchResults: PropTypes.bool,
  isAdministrator: PropTypes.bool
}
function mapStateToProps(state, ownProps) {

  const formName = ownProps.form
  const selector = formValueSelector(formName)
  const norecordsfound = selector(state, 'norecordsfound')
  const refreshSearchResults = selector(state, 'refreshSearchResults')

  return {
    norecordsfound,
    refreshSearchResults,
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchActiveSeasons,
    deleteEvent,
    cancelEvent,
    copyEvent,
    approveRules,
    denyRules,
    resetEventWizard
  }, dispatch)
}
export default reduxForm({
  form: formName,
  destroyOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(SearchResults))



// WEBPACK FOOTER //
// ./src/containers/event/components/searchresults.js